(() => {
  const WHATSAPP_URL = 'https://wa.me/442072456236';

  const removeLegacyWhatsAppShortcuts = () => {
    document.querySelectorAll('.hce-header-whatsapp, .hce-drawer-contact').forEach((node) => node.remove());
  };

  const refineCollectionRail = () => {
    const rail = document.querySelector('[data-hce-collection-rail]');
    if (!rail) return;

    rail.style.setProperty('background', '#eef0f4', 'important');
    rail.style.setProperty('border-top', '1px solid rgba(40, 48, 82, .18)', 'important');
    rail.style.setProperty('border-bottom', '1px solid rgba(40, 48, 82, .24)', 'important');
    rail.style.setProperty('box-shadow', '0 5px 14px rgba(19, 22, 33, .045)', 'important');
  };

  const restoreMobileDrawerUtilities = () => {
    const drawer = document.getElementById('mobNavDrawer');
    const list = drawer?.querySelector('.header-nav-drawer-linklist');
    const utilities = list?.querySelector('.mob-drawer--market-menu');
    const nav = list?.querySelector(':scope > nav');
    if (!list || !utilities || !nav) return;

    utilities.classList.remove('hce-mobile-utilities');
    utilities.removeAttribute('aria-label');

    /* Mayfair's native and cleaner order: catalogue navigation first,
       then account / country-currency / language near the bottom. */
    if (nav.nextElementSibling !== utilities) {
      nav.insertAdjacentElement('afterend', utilities);
    }
  };

  const markFooterContacts = () => {
    document.querySelectorAll(`a[href="${WHATSAPP_URL}"]`).forEach((link) => {
      const row = link.closest('p');
      if (!row) return;
      const hasPhone = row.querySelector('a[href^="tel:"]');
      const hasEmail = row.querySelector('a[href^="mailto:"]');
      const hasInstagram = row.querySelector('a[href*="instagram.com"]');
      if (hasPhone && hasEmail && hasInstagram) row.classList.add('hce-footer-contact-links');
    });
  };


  /* HCE mobile collection navigation prototype — 2026-09-22 */
  const initMobileCollectionRail = () => {
    const rail = document.querySelector('[data-hce-collection-rail]');
    if (!rail) return;

    const inner = rail.querySelector(':scope > .hce-collection-rail__inner');
    if (!inner) return;

    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;
    const viewAllLabel = (rail.dataset.hceViewAll || 'View all').trim();

    let panels = rail.querySelector(':scope > .hce-collection-rail__mobile-panels');
    if (!panels) {
      panels = document.createElement('div');
      panels.className = 'hce-collection-rail__mobile-panels';
      inner.insertAdjacentElement('afterend', panels);
    }

    const closePanels = () => {
      rail.querySelectorAll('[data-hce-mobile-collection-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
      panels.querySelectorAll('.hce-collection-rail__mobile-panel.is-open').forEach((panel) => {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      rail.classList.remove('hce-mobile-panel-open');
      document.body?.classList.remove('hce-mobile-panel-open');
    };

    const items = Array.from(inner.querySelectorAll(':scope > .hce-collection-rail__item.has-dropdown'));

    items.forEach((item, index) => {
      const trigger = item.querySelector(':scope > .hce-collection-rail__link');
      const source = item.querySelector(':scope > .hce-collection-rail__dropdown .hce-collection-rail__dropdown-inner');
      if (!trigger || !source) return;

      const panelId = 'HceMobileCollectionPanel-' + index;
      const parentTitle = (trigger.textContent || '').replace(/\s+/g, ' ').trim();

      trigger.dataset.hceMobileCollectionTrigger = panelId;
      trigger.setAttribute('aria-controls', panelId);
      trigger.setAttribute('aria-expanded', 'false');

      if (!trigger.querySelector('.hce-collection-rail__mobile-caret')) {
        const caret = document.createElement('span');
        caret.className = 'hce-collection-rail__mobile-caret';
        caret.setAttribute('aria-hidden', 'true');
        trigger.appendChild(caret);
      }

      let panel = panels.querySelector('#' + panelId);
      if (!panel) {
        panel = document.createElement('div');
        panel.id = panelId;
        panel.className = 'hce-collection-rail__mobile-panel';
        panel.setAttribute('aria-hidden', 'true');

        const viewAll = document.createElement('a');
        viewAll.className = 'hce-collection-rail__mobile-view-all';
        viewAll.href = trigger.href;

        const viewAllText = document.createElement('span');
        viewAllText.textContent = viewAllLabel + ' ' + parentTitle;

        const arrow = document.createElement('span');
        arrow.className = 'hce-collection-rail__mobile-view-all-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';

        viewAll.append(viewAllText, arrow);

        const grid = document.createElement('div');
        grid.className = 'hce-collection-rail__mobile-panel-grid';

        source.querySelectorAll('.hce-collection-rail__dropdown-link').forEach((sourceLink) => {
          const link = document.createElement('a');
          link.className = 'hce-collection-rail__mobile-panel-link';
          link.href = sourceLink.href;
          link.textContent = (sourceLink.textContent || '').replace(/\s+/g, ' ').trim();
          grid.appendChild(link);
        });

        panel.append(viewAll, grid);
        panels.appendChild(panel);
      }
    });

    if (rail.dataset.hceMobileRailBound !== 'true') {
      rail.dataset.hceMobileRailBound = 'true';

      rail.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-hce-mobile-collection-trigger]');
        if (trigger && rail.contains(trigger) && isMobile()) {
          event.preventDefault();

          const panelId = trigger.dataset.hceMobileCollectionTrigger;
          const panel = panelId ? panels.querySelector('#' + panelId) : null;
          if (!panel) return;

          const wasOpen = panel.classList.contains('is-open');
          closePanels();

          if (!wasOpen) {
            panel.classList.add('is-open');
            panel.setAttribute('aria-hidden', 'false');
            trigger.setAttribute('aria-expanded', 'true');
            rail.classList.add('hce-mobile-panel-open');
            document.body?.classList.add('hce-mobile-panel-open');

            const item = trigger.closest('.hce-collection-rail__item');
            if (item) {
              const targetLeft = Math.max(
                0,
                item.offsetLeft - ((inner.clientWidth - item.offsetWidth) / 2)
              );
              inner.scrollTo({ left: targetLeft, behavior: 'smooth' });
            }
          }
          return;
        }

        if (event.target.closest('.hce-collection-rail__mobile-panel a')) {
          closePanels();
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') closePanels();
      });

      window.addEventListener('resize', () => {
        if (!isMobile()) closePanels();
      });
    }

    const updateFades = () => {
      const maxScroll = Math.max(0, inner.scrollWidth - inner.clientWidth);
      rail.classList.toggle('hce-can-scroll-left', inner.scrollLeft > 5);
      rail.classList.toggle('hce-can-scroll-right', inner.scrollLeft < maxScroll - 5);
    };

    if (inner.dataset.hceMobileFadeBound !== 'true') {
      inner.dataset.hceMobileFadeBound = 'true';
      inner.addEventListener('scroll', () => window.requestAnimationFrame(updateFades), { passive: true });
    }

    window.requestAnimationFrame(updateFades);

    /* HCE mobile collection rail discovery nudge — 2026-09-22 */
    if (rail.dataset.hceMobileNudgeBound !== 'true') {
      rail.dataset.hceMobileNudgeBound = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let nudgeCancelled = false;
      let nudgeStarted = false;
      let visibilityObserver = null;
      let nudgeFrame = null;
      let restoreNudgeStyles = null;
      const timers = [];

      const clearNudgeTimers = () => {
        while (timers.length) window.clearTimeout(timers.pop());
      };

      const stopNudgeAnimation = () => {
        if (nudgeFrame !== null) {
          window.cancelAnimationFrame(nudgeFrame);
          nudgeFrame = null;
        }
        if (restoreNudgeStyles) {
          restoreNudgeStyles();
          restoreNudgeStyles = null;
        }
      };

      const cancelNudges = () => {
        if (nudgeCancelled) return;
        nudgeCancelled = true;
        clearNudgeTimers();
        stopNudgeAnimation();
        visibilityObserver?.disconnect();
        window.removeEventListener('scroll', startIfVisible);
        window.removeEventListener('resize', startIfVisible);
      };

      const railIsVisible = () => {
        if (!isMobile()) return false;
        const styles = window.getComputedStyle(rail);
        const rect = rail.getBoundingClientRect();
        return styles.visibility !== 'hidden'
          && Number.parseFloat(styles.opacity || '1') > 0.05
          && rect.height > 0
          && rect.bottom > 0
          && rect.top < window.innerHeight;
      };

      const animateRail = (from, to, duration, onDone) => {
        const startedAt = performance.now();
        const easeInOutSine = (progress) => -(Math.cos(Math.PI * progress) - 1) / 2;

        const frame = (now) => {
          if (nudgeCancelled) return;
          const progress = Math.min(1, (now - startedAt) / duration);
          inner.scrollLeft = from + ((to - from) * easeInOutSine(progress));
          updateFades();

          if (progress < 1) {
            nudgeFrame = window.requestAnimationFrame(frame);
          } else {
            nudgeFrame = null;
            onDone?.();
          }
        };

        nudgeFrame = window.requestAnimationFrame(frame);
      };

      const runNudge = () => {
        if (nudgeCancelled || reduceMotion.matches || !railIsVisible()) return;
        if (rail.classList.contains('hce-mobile-panel-open')) return;

        const maxScroll = Math.max(0, inner.scrollWidth - inner.clientWidth);
        if (maxScroll < 12) return;

        const start = inner.scrollLeft;
        const direction = window.getComputedStyle(inner).direction === 'rtl' ? -1 : 1;
        const target = Math.max(0, Math.min(maxScroll, start + (24 * direction)));
        if (Math.abs(target - start) < 8) return;

        const previousSnap = inner.style.scrollSnapType;
        const previousBehavior = inner.style.scrollBehavior;

        inner.style.scrollSnapType = 'none';
        inner.style.scrollBehavior = 'auto';

        restoreNudgeStyles = () => {
          inner.style.scrollSnapType = previousSnap;
          inner.style.scrollBehavior = previousBehavior;
          window.requestAnimationFrame(updateFades);
        };

        animateRail(start, target, 1350, () => {
          if (nudgeCancelled) return;
          animateRail(target, start, 1350, () => {
            restoreNudgeStyles?.();
            restoreNudgeStyles = null;
          });
        });
      };

      function startIfVisible() {
        if (nudgeStarted || nudgeCancelled || reduceMotion.matches || !railIsVisible()) return;
        nudgeStarted = true;
        visibilityObserver?.disconnect();
        window.removeEventListener('scroll', startIfVisible);
        window.removeEventListener('resize', startIfVisible);

        timers.push(window.setTimeout(runNudge, 4000));
        timers.push(window.setTimeout(runNudge, 14000));
      }

      rail.addEventListener('pointerdown', cancelNudges, { passive: true });
      rail.addEventListener('touchstart', cancelNudges, { passive: true });
      rail.addEventListener('click', cancelNudges);
      rail.addEventListener('keydown', cancelNudges);
      inner.addEventListener('wheel', cancelNudges, { passive: true });

      visibilityObserver = new MutationObserver(startIfVisible);
      visibilityObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('scroll', startIfVisible, { passive: true });
      window.addEventListener('resize', startIfVisible, { passive: true });

      startIfVisible();
    }
  };

  const init = () => {
    removeLegacyWhatsAppShortcuts();
    refineCollectionRail();
    initMobileCollectionRail();
    restoreMobileDrawerUtilities();
    markFooterContacts();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
